<template>
    <div>
        <div class="animationConatiner">
        <transition name="slideSettings" mode="out-in" appear>
        <div v-if="gameSetting">
            <div class="gameSetting">
         <p>Number of decks :</p> <input type="number" v-model="decks" /> 

        <p>Negative marking?</p>        
        <div class="negativeSetting">
            <p v-bind:class="{notred: !negative}" >No :</p><input type="radio" :value="false" v-model="negative">
            <p v-bind:class="{red: negative}" >Yes: </p><input type="radio" :value="true" v-model="negative">
        </div>
        

        <p>Lowest Round limit:</p><input type="number" v-model="minCards" />
        <p>Number of players:</p><input type="number" v-model="players" />

        <!-- <br>
        {{decks}}
        {{negative}}
        {{players}}
        <br> -->
        </div>
        <div class="buttonContainer">
        <button @click="startName()" class="mybutton">Next</button>
        </div>
        </div>
        </transition>
        </div>
        <!-- <br>
        {{minCards}}
        {{maxCards}}

        <br> -->

        <transition name="slideSettings" mode="out-in">
        <div v-if="gameName" class="gameNameContainer">
            <p class="enterName">ENTER NAMES</p>
            <div v-for="(item,index) in parseInt(players)" :key="item" class="gameName">
                <p> player {{item}}</p> <input type="text" v-model="playerNames[index]" />
            </div>
            <div class="buttonContainer">
            <button @click="startStr()" class="mybutton">start</button>
            </div>
        </div>
        </transition>
        <!-- {{playerNames}} -->

        <transition name="slideSettings" mode="out-in">
        <div v-if="gameStart">
            <div v-if="refresh"> 
        
        <div class="powerInstructions">
          <p v-bind:class="{red: suits[suitActive].red,notred:!suits[suitActive].red}" class="powerSuit">{{suits[suitActive].symbol}}</p>

        <div class="cardNum">
          <h3>{{currentNum}} </h3>
          <p> cards per person</p>
        </div>

        <div class="cardNum">
          <h3  v-bind:class="{red: totalCurrHands==currentNum}" >{{totalCurrHands}} </h3>
          <p> current hands</p>
        </div>

            <p v-bind:class="{red: suits[suitActive].red,notred:!suits[suitActive].red}" class="powerSuit"> {{suits[suitActive].name}}</p>
        </div>

        <hr class="myLine">

            <div class="gameContent">
                <h3>Name</h3>
                <h3>Points</h3>
                <h3>Hands</h3>
                <h3>Lost?</h3>

            </div>
        <div v-for="(data, index) in game" :key="index" class="gameContent">
            <!-- <p>{{data}}</p> -->

            <p v-bind:class="{turn: data.turn}" class="allNames">{{data.name}}</p>
            <p>{{game[index].points}}</p>
            <input v-if="!locked" type="number" min="0" @change="printpls(index)"/>
            <p v-if="locked">{{game[index].toEarn}}</p>
            <input :disabled="!locked" type="checkbox" :value="index" v-model="failedPlayers">

        </div>
        </div>
        <div class="buttonContainer buttongrid">
            <button @click="lockOption()" :disabled="locked || totalCurrHands==currentNum" class="choice">lock hands</button>
            <button @click="nextState()" :disabled="!locked" class="choice">next round</button>
        </div>

            <div class="negativeInfo">
              <p v-if="negative"> Negative marking : ON</p><p v-else>Negative marking : OFF</p>
            </div>

        <!-- <p>failed people : {{failedPlayers}}</p>
        <p v-if="gameStart">GAME : {{game}}</p> -->
        </div>
        </transition>

    </div>
</template>
<script>
export default {
    data() {
        return {
            decks:1,
            negative:false,
            players:1,
            // maxPlayers:null,
            minCards:0,
            maxCards:null,
            gameSetting:true,
            gameName:false,
            playerNames:[],
            game:[],
            failedPlayers:[],
            myturn:0,
            locked:false,
            refresh:true,
            suits:[ {symbol:"♠",red:false,name:"Spade"},
                    {symbol:"♦",red:true,name:"Diamond"},
                    {symbol:"♣",red:false,name:"Club"},
                    {symbol:"♥",red:true,name:"Heart"}],
            suitActive:0,
            currentNum:null,
            goingDown:true,
            // uniAtr:{},
            gameStart:false,
            totalCurrHands:0,
        };
  },
  methods: {
      startName(){
          if(this.decks>=1 && this.minCards>=0 && this.players>=1){

              this.maxCards = Math.floor((this.decks*52)/this.players);
            //   this.maxPlayers = this.players;
            this.gameSetting=false;
              this.gameName = true;
          }
      },
      startStr(){

          var allowToProceed=true;

        for(var i=0;i<this.players;i++){
            
            if(this.playerNames[i]==null || this.playerNames[i].trim()==""){
                alert("Invalid Name(s)");
                allowToProceed=false;
            }

            if(i==0){
                this.game[i]={name:this.playerNames[i],points:0,toEarn:0,turn:true};
            }
            else{
                this.game[i]={name:this.playerNames[i],points:0,toEarn:0,turn:false};
            }
        }
        // this.playerNames.forEach(function(entry) {

            // });
            if(allowToProceed==true){
                this.currentNum=this.maxCards;
                this.gameName=false;
                this.gameStart=true;
            }
        //   console.log(this.game);

      },
      printpls(key){
        //   console.log("MYPRINT");
        if(event.target.value>=0){
            this.game[key].toEarn = event.target.value;
            
            var totalHands = [];
            for(var i=0;i<this.players;i++){
            totalHands[i] = parseInt(this.game[i].toEarn);
            }
            this.totalCurrHands = totalHands.reduce((a, b) => a + b, 0);
            // console.log(this.totalCurrHands);
        }
      },
      nextState(){

        this.totalCurrHands = 0;

        for(var i=0;i<this.players;i++){
            if(!this.failedPlayers.includes(i)){
                if(this.game[i].toEarn==0){
                     this.game[i].points+=10;
                }else{
                    this.game[i].points+=this.game[i].toEarn*10;
                }
            }
            else{
                if(this.negative==true){
                    if(this.game[i].toEarn==0){
                     this.game[i].points-=10;
                        }else{
                    this.game[i].points-=this.game[i].toEarn*10;
                    }

                }
            }
            this.game[i].toEarn=0;
        }

        this.game[this.myturn].turn=false;
        if(this.myturn+1>=this.players){
            this.myturn=0;
        }else{
            this.myturn+=1;
        }
        this.game[this.myturn].turn=true;

        this.suitActive+=1;
        if(this.suitActive>=4){
            this.suitActive=0;
        }

        if(this.goingDown==true){
            this.currentNum-=1;
        }
        else if(this.goingDown==false){
            this.currentNum+=1;
        }

        if(this.currentNum==this.minCards){
            this.goingDown=false;
        }
        else if(this.currentNum==this.maxCards){
            this.goingDown=true;
        }


        this.locked=false;
        this.failedPlayers=[];

        this.$nextTick(function () {this.refresh=false;
            this.$nextTick(function () {this.refresh=true;})
            })

        // console.log(this.game);
      },
      lockOption(){
          this.locked=true
      }
  }
    
}
</script>

<style scoped>
input, select, textarea{
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    color: white;
    background: transparent;
    border: none;
    border-bottom: 1px dashed white;
    padding: 10px 5px;
}

input[type="text"],input[type="number"]{
    width: 80%;
}

.turn{
    color: rgb(192, 32, 192);
    font-weight: bolder;
    text-transform: uppercase;
    

}

.red{
    color: rgb(236, 53, 53);
}
.notred{
    color: rgb(68, 180, 250);
}


.gameSetting{
    margin-top: 2em ;
    display: -ms-grid;
    display: grid;
    -ms-grid-columns:1fr 3fr;
    grid-template-columns:1fr 3fr;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.gameSetting p,.gameName p {
font-family: 'Courier New', Courier, monospace;
}

.negativeSetting{
    /* margin-top: 2em ; */
    display: -ms-grid;
    display: grid;
    -ms-grid-columns:1fr 9fr ;
    grid-template-columns:1fr 9fr ;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}


.gameNameContainer{
    margin-top: 2em ;
}

.enterName {
    font-family: 'Courier New', Courier, monospace;
    font-size: 1.3em;
}

.gameName{
    display: -ms-grid;
    display: grid;
    -ms-grid-columns:1fr 6fr;
    grid-template-columns:1fr 6fr;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.gameContent{
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    display: -ms-grid;
    display: grid;
    -ms-grid-columns:1fr 1fr 1fr 1fr;
    grid-template-columns:1fr 1fr 1fr 1fr;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    text-align: center;
}

.gameContent input{
    margin:0 auto;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    text-align: center;
}

.gameContent h3{
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}



.powerInstructions{
    display: -ms-grid;
    display: grid;
    -ms-grid-columns:1fr 1fr 1fr 1fr;
    grid-template-columns:1fr 1fr 1fr 1fr;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.powerSuit{
    font-size: 2em;
    text-align: center;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.cardNum{
    -ms-flex-item-align: center;
        -ms-grid-row-align: center;
        align-self: center;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    text-align: center;
}

.cardNum p,.cardNum h3{
    margin: 0;
}

.cardNum h3{
    font-size: 2em;
    font-weight: normal;
}

.buttonContainer{
    text-align: center;
}

.mybutton{
    margin-top: 2em;
    width: 50%;
    color: black;
    background: white;
    -webkit-transition: 0.4s ease;
    -o-transition: 0.4s ease;
    transition: 0.4s ease;
    font-family: 'Courier New', Courier, monospace;
    font-size: 1em;
}

.mybutton:hover{
    width: 90%;
}


.buttongrid{
    margin-top: 2em;
    margin-bottom: 2em;
    display: -ms-grid;
    display: grid;
    -ms-grid-columns:1fr 1fr ;
    grid-template-columns:1fr 1fr ;
}


.choice{
    color: black;
    background: white;
    -webkit-transition: 0.4s ease;
    -o-transition: 0.4s ease;
    transition: 0.4s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    padding: 0.5em;
}

.choice:disabled{
    opacity: 0.2;
    background: white;
}


.negativeInfo p{
    font-family: 'Courier New', Courier, monospace;
    text-align: center;
    opacity: 0.7;
}


input[type="checkbox"]{
    -webkit-appearance: initial;
    -moz-appearance: initial;
         appearance: initial;
    background: lightgrey;
    width: 30px;
    height: 30px;
    border: none;
    position: relative;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}


input[type="checkbox"]:disabled{
opacity: 0.2;

}

input[type="checkbox"]:checked {
    background: rgb(255, 30, 30);
}

input[type="checkbox"]:checked:after {
    /* Heres your symbol replacement */
    content: "X";
    color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
}


.animationConatiner{
    overflow: hidden;
}

.slideSettings-enter-active{
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  -webkit-transition-delay: 0.6s;
       -o-transition-delay: 0.6s;
          transition-delay: 0.6s;
}
.slideSettings-leave-active {
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.slideSettings-enter {
  opacity: 0;
}
.slideSettings-leave-to {
  opacity: 0;
}

</style>>

